module.exports = __webpack_public_path__ + "img/icon-sta3.ca84bbe8.png";